import { render, staticRenderFns } from "./TxRowActionBadgeMobile.vue?vue&type=template&id=de6fa3d0"
import script from "./TxRowActionBadgeMobile.vue?vue&type=script&lang=js"
export * from "./TxRowActionBadgeMobile.vue?vue&type=script&lang=js"
import style0 from "./TxRowActionBadgeMobile.vue?vue&type=style&index=0&id=de6fa3d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports